import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { COMPANY } from "../data/company";

const LEGAL_LINKS = [
  ["About", "/about"],
  ["Contact", "/contact"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
  ["Refunds", "/refunds"],
];

export const Footer = () => (
  <footer className="no-print border-t border-black/5 mt-16" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <Compass className="w-5 h-5 text-[#C8553D]" strokeWidth={1.75} />
        <span className="font-display text-xl">WanderlyMe</span>
        <span className="text-sm text-muted-foreground ml-2">Travel planned around you</span>
      </div>
      <nav className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-sm text-muted-foreground">
        <Link to="/features" className="hover:text-[#C8553D] transition-colors" data-testid="footer-link-features">How it works</Link>
        <Link to="/destinations" className="hover:text-[#C8553D] transition-colors">Destinations</Link>
        <Link to="/travel-guide" className="hover:text-[#C8553D] transition-colors">Travel guide</Link>
        <Link to="/plan" className="hover:text-[#C8553D] transition-colors">Plan a trip</Link>
        <Link to="/plan-with-us" className="hover:text-[#C8553D] transition-colors" data-testid="footer-link-plan-with-us">Plan with us</Link>
        <Link to="/plans" className="hover:text-[#C8553D] transition-colors" data-testid="footer-link-plans">Pricing</Link>
      </nav>
    </div>
    <div className="border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-muted-foreground" aria-label="Legal" data-testid="footer-legal-nav">
          {LEGAL_LINKS.map(([label, to], i) => (
            <span key={to} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden="true">·</span>}
              <Link to={to} className="hover:text-[#C8553D] transition-colors" data-testid={`footer-link-${label.toLowerCase()}`}>{label}</Link>
            </span>
          ))}
        </nav>
        <p className="text-xs text-muted-foreground text-center sm:text-right">
          © {new Date().getFullYear()} {COMPANY.tradingName} · {COMPANY.operator}, {COMPANY.location} · ABN {COMPANY.abn}
        </p>
      </div>
    </div>
  </footer>
);
